import { isAndroidWebView, isLinux } from '@eventbrite/feature-detection';
import { TicketsFormat } from '../../constants/statsig';
import { CheckoutState } from '../../state';
import { getIsReservedSeating } from '../event';
import { getHasAddonsTicketsWithMoreThanOneVariant } from '../tickets/getHasAddonsTicketsWithMoreThanOneVariant';
import { getNamespaceValue } from '../utils/selector';

export const getSupportedTicketFormat = (
    state: CheckoutState,
): TicketsFormat => {
    return (getIsReservedSeating(state) &&
        getHasAddonsTicketsWithMoreThanOneVariant(state)) ||
        // TODO: EB-208841 - Exclude Linux until it is supported
        (isLinux() && !isAndroidWebView())
        ? TicketsFormat.listItem
        : TicketsFormat.card;
};

export const getHasBogoTickets = (state: CheckoutState): boolean => {
    return getNamespaceValue(state.event, 'hasBogoTickets');
};
